import React, { useState } from "react";
import { Radio, RadioGroup } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import RouteNames from "../../routes/type";
import { BackButton, Button } from "../../components";
import { classNames } from "../../helper";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { resetSearchTry } from "../../store/user/actions";

interface FindclaimMethod {
  name: string;
  navigateTo: RouteNames;
  disabled?: boolean;
}

const findclaimMethod: FindclaimMethod[] = [
  {
    name: "I have my warranty number",
    navigateTo: RouteNames.WARRANTY_NUMBER,
  },
  {
    name: "Lookup based on personal information",
    navigateTo: RouteNames.SEARCH_BY_PERSONAL_INFO,
  },
];

function FindPlan() {
  const [selected, setSelected] = useState<FindclaimMethod | null>(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const handleSearchByWarrantyNumber = () => {
    dispatch(resetSearchTry());
    navigate(`/${selected?.navigateTo}`);
  };

  return (
    <div className="px-4">
      <div className="mb-8 mt-6">
        <BackButton />
      </div>
      <div className="mb-8">
        <h3 className="text-2xl font-semibold">
          {t("We need to find your warranty")}
        </h3>
      </div>
      <div className="radio-group mb-8">
        <RadioGroup value={selected} onChange={setSelected}>
          <div className="space-y-6 rounded-xl bg-white">
            {findclaimMethod.map((method) => (
              <Radio
                key={method.name}
                value={method}
                disabled={method.disabled}
                className={({ checked, hover }) =>
                  classNames(
                    "rounded-xl",
                    checked
                      ? "bg-blue-light border-brand-color z-10"
                      : hover
                        ? "border-brand-color"
                        : "border-border-gray",
                    "relative border px-4 py-6 flex cursor-pointer focus:outline-none disabled:cursor-not-allowed"
                  )
                }
              >
                {({ checked, hover }) => (
                  <>
                    <span
                      className={classNames(
                        checked
                          ? "bg-brand-color border-transparent"
                          : "bg-white border-gray-300",
                        hover ? "ring-1 ring-offset-2 ring-brand-color" : "",
                        "mt-0.5 h-4 w-4 shrink-0  rounded-full border flex items-center justify-center"
                      )}
                      aria-hidden="true"
                    >
                      <span className="rounded-full bg-white w-1.5 h-1.5" />
                    </span>
                    <span className="ml-3 flex flex-col">
                      <label
                        className={classNames(
                          checked ? "text-brand-color" : "text-gray-900",
                          "block text-base"
                        )}
                      >
                        {t(method.name)}
                      </label>
                    </span>
                  </>
                )}
              </Radio>
            ))}
          </div>
        </RadioGroup>
      </div>
      <Button onClick={handleSearchByWarrantyNumber} disabled={!selected}>
        {t("Search")}
      </Button>
    </div>
  );
}

export default FindPlan;
